import { CallMeAction, CallMeActionKind } from '../types';
import { logInfoMessage } from './utils';
import { STATUS_MESSAGE } from '../constants/StatusMessages';

export function dispatchProperMessage(
  statusCodeResponse: string,
  dispatch: (value: CallMeAction) => void
) {
  let statusMessage = '';
  switch (statusCodeResponse) {
    case '0':
      statusMessage = STATUS_MESSAGE.OK;
      break;
    case '-1':
      statusMessage = STATUS_MESSAGE.INVALID_PHONE;
      break;
    case '3001':
      statusMessage = STATUS_MESSAGE.INVALID_PHONE;
      break;
    case '2010':
      statusMessage = STATUS_MESSAGE.ALREADY_REGISTERED;
      break;
    case '1200':
      statusMessage = STATUS_MESSAGE.ERROR;
      break;
    case '15':
      statusMessage = STATUS_MESSAGE.ERROR;
      break;
    case '4005':
      statusMessage = STATUS_MESSAGE.CLOSED;
      break;
    case 'duplicate_phone_number':
      statusMessage = STATUS_MESSAGE.DUPLICATE_PHONE_NUMBER;
      break;
  }
  logInfoMessage(statusCodeResponse);
  dispatch({
    payload: statusMessage,
    type:
      statusCodeResponse === '0'
        ? CallMeActionKind.SET_SUCCESS
        : CallMeActionKind.SET_FAILURE
  });
}
